import React, { Component } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { createBrowserHistory } from "history";
import GTM from "react-tag-manager";

import InbioHome from "views/InbioHome";
import NotFound from "views/404";

const history = createBrowserHistory();

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

class AppRoutes extends Component {
  state = {};

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <Router history={history}>
        <GTM
          gtm={{
            id: "GTM-5GJR5WK",
          }}
          {...this.props}
        >
          <Switch>
            <Route exact path="/:campaign_id" component={InbioHome} />
            <Route path="/" component={NotFound} />
          </Switch>
        </GTM>
      </Router>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
